var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPlaylistThumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 280,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 116.668H110V123.335H150V116.668ZM150 130.001H110V136.668H150V130.001ZM110 150.001H136.667V143.335H110V150.001ZM156.667 116.668V143.935C155.633 143.568 154.5 143.335 153.333 143.335C147.8 143.335 143.333 147.801 143.333 153.335C143.333 158.868 147.8 163.335 153.333 163.335C158.867 163.335 163.333 158.868 163.333 153.335V123.335H173.333V116.668H156.667Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPlaylistThumbnail);
export default __webpack_public_path__ + "static/media/default_playlist_thumbnail.b7a81261a9acd6f8062da201c66d8a29.svg";
export { ForwardRef as ReactComponent };